import { postMethodWithToken, putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const ASSIGN_SPECIALIST_VERIFY = 'ASSIGN_SPECIALIST_VERIFY';
export const ASSIGN_SPECIALIST_VERIFY_SUCCESS =
  'ASSIGN_SPECIALIST_VERIFY_SUCCESS';
export const ASSIGN_SPECIALIST_VERIFY_FAILURE =
  'ASSIGN_SPECIALIST_VERIFY_FAILURE';

// Action Creators
export const fetchAssignSpecialistVerify = () => ({
  type: ASSIGN_SPECIALIST_VERIFY,
});

export const fetchAssignSpecialistVerifySuccess = (data) => ({
  type: ASSIGN_SPECIALIST_VERIFY_SUCCESS,
  payload: data,
});

export const fetchAssignSpecialistVerifyFailure = (error) => ({
  type: ASSIGN_SPECIALIST_VERIFY_FAILURE,
  payload: error,
});

// Thunk Function
export const assignSpecialistVerifyProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchAssignSpecialistVerify(data, external));
    try {
      const response = await postMethodWithToken(
        url.assignSpecialistVerify,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchAssignSpecialistVerifySuccess(response.data));
        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchAssignSpecialistVerifyFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchAssignSpecialistVerifyFailure(error.message));
    }
  };
};
